/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContextPart {
    Tenant = 1,
    Location = 2,
    LocationGroup = 3,
    SystemRole = 7,
    LocationRelated = 8,
    Permission = 9,
    AccessByLocation = 15,
    AccessByLocationGroup = 16,
    AccessByUser = 17,
    AccessBySafeKeeper = 20,
    ReceiverUser = 21,
}
